/*
  下载和导出
*/
import request from "@/utils/request";

//下载教师信息模板
export function downloadTeacherInfo() {
  return request({
    url: "/baseinfo/teacherinfo/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}

//导出教师信息
export function exportTeacherInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/export",
    method: "get",
    responseType: "blob",
    params
  });
}

// 导出教师信息附表（市县×学科矩阵，0205）
export function exportTeacherSubjectSupplement(params) {
  return request({
    url: "/baseinfo/teacherinfo/exportSubjectSupplement",
    method: "get",
    responseType: "blob",
    params
  });
}

//下载评卷质量信息模板
export function downloadMarkQuality() {
  return request({
    url: "/markteacher/markquality/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}

//导出评卷质量信息
export function exportMarkQuality(params) {
  return request({
    url: "/markteacher/markquality/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//下载评卷教师评价模板
export function downloadMarkingTeacherEvaluateTemplate(params) {
  return request({
    url: window.config.baseUrl4Shool+"/markteacher/markTchEvaluate/downloadTemplate",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出评卷教师选拔信息
export function exportMarkingTeacherChoose(params) {
  return request({
    url: "/markteacher/markTchSelect/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出评卷聘用管理信息
export function exportMarkingEmployManage(params) {
  return request({
    url: "/markteacher/markEmployMag/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出聘用信息
export function exportEmployInfo(params) {
  return request({
    url: "/markteacher/employInfo/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出评卷历史统计
export function exportMarkHistoryStatistics(params) {
  return request({
    url: "/markteacher/markHistoryStatistics/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出日志管理信息
export function exportLog(params) {
  return request({
    url: "/log/logManage/export",
    method: "get",
    responseType: "blob",
    params
  });
}

// 导入文件失败提示
export function downloadErrorFile(params: object) {
  return request({
    url: "/common/errorFile",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出命题教师聘用信息
export function exportPropositionTeacherEmploy(params) {
  return request({
    url: "/propositionteacher/propositionTchEmploy/export",
    method: "get",
    responseType: "blob",
    params
  });
}

//导出命题教师评价信息
export function exportPropositionTchEvaluate(params) {
  return request({
    url: '/propositionteacher/propositionTchEvaluate/export',
    method: "get",
    responseType: "blob",
    params
  });
}

// 导出教官聘用列表
export function exportExaminerEmploy(params) {
  return request({
    url: '/examinerteacher/examinerEmploy/export',
    method: "get",
    responseType: "blob",
    params
  });
}

//导出考官教师评价信息
export function exportExaminerEvaluate(params) {
  return request({
    url: '/examinerteacher/examinerEvaluate/export',
    method: "get",
    responseType: "blob",
    params
  });
}

//导出项目信息
export function exportProjectMsgManage(params) {
  return request({
    url: '/baseinfo/projectMsgManage/export',
    method: "get",
    responseType: "blob",
    params
  });
}

//下载市区模板
export function downloadDistrictTemplate() {
  return request({
    url: "/sysmange/district/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}

//下载单位模板
export function downloadSchoolTemplate() {
  return request({
    url: "/sysmange/school/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}

// 下载项目信息导入模板
export function downloadProjectManageTemplate() {
  return request({
    url: "/baseinfo/projectMsgManage/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}


//下载项目教师审核模板
export function downloadAuditTeacherInfo() {
  return request({
    url: "/baseinfo/teacherinfo/downloadAuditTeacherInfo",
    method: "get",
    responseType: "blob"
  });
}

//下载教师名单维护导入模板
export function downloadTeacherMaintainTemplate() {
  return request({
    url: "/baseinfo/maintain/downloadTemplate",
    method: "get",
    responseType: "blob"
  });
}

//导出教师名单维护信息
export function exportTeacherMaintain(params) {
  return request({
    url: "/baseinfo/maintain/export",
    method: "get",
    responseType: "blob",
    params
  });
}


//导出教师信息
export function exportAuditTeacherInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/exportPdf",
    method: "get",
    responseType: "blob",
    params
  });
}

